import React, { useEffect, useState } from 'react';
import { TableData, WorkArea } from 'components';
import { getPublicAlertMonitorService } from 'services/admin/alertsService';
import { errorAlert } from 'helpers/alerts';
import moment from 'moment';
import { Box, Grid, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

const PublicAlertTxnsMonitorScreen = () => {
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(false)
  const params = useParams();

  useEffect(() => {
    setLoading(true);
    getPublicAlertMonitorService(params.id).then((response) => {
      setAlert(response)
    }).catch(error => errorAlert(error))
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  return (
    <WorkArea>
      <Box mt={4}>
        <Box textAlign={'center'}>
          <Typography variant="h5" component="h1" fontWeight={'bold'}>
            Alerta ID: {alert?.identification}
          </Typography>
          <Typography variant="h6" component="h2">
            {alert?.message}
          </Typography>
          <Typography variant="body1" component="p">
            {moment(alert?.createdAt).format("DD/MM/YYYY HH:mm:ss")}
          </Typography>
        </Box>
        <TableData
          dataRows={alert?.txns}
          loading={loading}
          dataTitle={[
            "Fecha Hora",
            "Bolsa",
            "Operadora",
            "Producto",
            "Monto",
            "Número",
            "Código",
            "Estado",
            "Tiempo",
          ]}
          formatter={({
            createdAt,
            hosterBagId,
            operator,
            amount,
            phoneNumber,
            productId,
            ProviderResponseCode,
            ProviderResponseMessage,
            time
          }) => [
              moment(createdAt).format('DD/MM/YYYY HH:mm:ss '),
              hosterBagId?.hashtag,
              operator,
              productId,
              `$ ${Number(amount || 0).toFixed(2)}`,
              phoneNumber,
              ProviderResponseCode,
              ProviderResponseMessage,
              `${time} ms`,
            ]}
        />
      </Box>
    </WorkArea>


  )
}

export default PublicAlertTxnsMonitorScreen